import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { AtlasToastService } from '@services/atlas-toast.service';
import { ToastContainerDirective } from 'ngx-toastr';

@Component({
  selector: 'wsb-shop-purchase-error',
  templateUrl: './shop-purchase-error.component.html',
  styleUrls: ['./shop-purchase-error.component.scss'],
  standalone: false
})
export class ShopPurchaseErrorComponent implements AfterViewInit {
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  constructor(private atlasToastService: AtlasToastService) {}

  ngAfterViewInit(): void {
    this.atlasToastService.error('shop_purchase_error_title', 'shop_purchase_error', -1, this.toastContainer);
  }
}
